import { useEffect, useState } from "react";

const PaymentIcons = () => {
  const [isMobile, setIsMobile] = useState(false);
  const base = window?.post_template?.checkout_v4_form;
  const icons = base?.checkout_v4_form_payment_icons?.checkout_v4_form_payment_icons_icon_images || [];

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 460);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const containerStyle = {
    display: "flex",
    gap: isMobile ? "21.78px" : "26px",
    marginTop: "16px",
    marginLeft: "auto",
    marginRight: "auto",
    marginBottom: isMobile ? "16px" : "45px",
    justifyContent: "center",
  };

  return (
    <div style={containerStyle}>
      {icons.map((icon, index) => (
        <img key={index} src={icon.icon_logo} style={{ height: isMobile ? "20px" : "26px" }} alt="Payment Icon" />
      ))}
    </div>
  );
};

export default PaymentIcons;
